import * as React from 'react'
import { IconWrapper } from '../IconWrapper'
import { IconProps } from '../iconConstants'

export const AiIcon = ({ title, titleId, ...props }: IconProps) => (
    <IconWrapper {...props}>
        <svg xmlns="http://www.w3.org/2000/svg" width="29" height="29" viewBox="0 0 29 29" fill="none">
            <path
                d="M18.7931 16.0376C14.0548 17.6344 12.4928 19.4123 11.3377 23.8405C10.1827 19.4123 8.62066 17.6344 3.88232 16.0376C8.62066 14.4409 10.1827 12.663 11.3377 8.23474C12.4928 12.663 14.0548 14.4409 18.7931 16.0376Z"
                stroke="url(#paint0_linear_6721_9923)"
                strokeWidth="1.8"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M24.6716 8.65078C21.9987 9.54785 21.1177 10.5468 20.4661 13.0347C19.8146 10.5468 18.9335 9.54785 16.2607 8.65078C18.9335 7.75372 19.8146 6.75478 20.4661 4.26685C21.1177 6.75478 21.9987 7.75372 24.6716 8.65078Z"
                stroke="url(#paint1_linear_6721_9923)"
                strokeWidth="1.8"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M25.0188 21.5841C23.0405 22.234 22.3883 22.9579 21.906 24.7608C21.4238 22.9579 20.7716 22.234 18.7932 21.5841C20.7716 20.934 21.4238 20.2102 21.906 18.4073C22.3883 20.2102 23.0405 20.934 25.0188 21.5841Z"
                stroke="url(#paint2_linear_6721_9923)"
                strokeWidth="1.8"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <defs>
                <linearGradient
                    id="paint0_linear_6721_9923"
                    x1="11.3377"
                    y1="8.23474"
                    x2="11.3377"
                    y2="23.8405"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#5C008C" />
                    <stop offset="1" stopColor="#DCBDEC" />
                </linearGradient>
                <linearGradient
                    id="paint1_linear_6721_9923"
                    x1="20.4662"
                    y1="4.26685"
                    x2="20.4662"
                    y2="13.0347"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#5C008C" />
                    <stop offset="1" stopColor="#DCBDEC" />
                </linearGradient>
                <linearGradient
                    id="paint2_linear_6721_9923"
                    x1="21.906"
                    y1="18.4073"
                    x2="21.906"
                    y2="24.7608"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#5C008C" />
                    <stop offset="1" stopColor="#DCBDEC" />
                </linearGradient>
            </defs>
        </svg>
    </IconWrapper>
)
